import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import ContentBlock from "@/components/wpl/content-block/src";
import { Picture } from "@/components/wpl/image/src";
import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";

export const EnterpriseSection = () => {
    const localizedCTAHRef = useLocalizedHref(
        "/software/views/community-license-request#/"
    );

    const containerStyles = css({
        display: "grid",
        margin: "auto",
        width: "100%",
        maxWidth: "900px",
        gap: token("space.600"),
        gridTemplateColumns: "1fr 1fr",
        alignItems: "center",
        textAlign: "left",
        [media.below.md]: {
            gridTemplateColumns: "1fr",
            textAlign: "center",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            [`.contentBlock-linkFlex`]: {
                justifyContent: "center"
            }
        }
    });

    const pictureStyles = css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        [`picture, img`]: {
            minWidth: "50%",
            maxWidth: "100%",
            height: "auto",
            margin: "auto"
        }
    });

    const contentBlockStyles = css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h3: {
            lineHeight: 1.1875,
            fontWeight: 600,
            fontSize: token("space.400"),
            color: wacToken("color.primary.black")
        }
    });

    const intl = useIntl();

    return (
        <div css={containerStyles}>
            <div>
                <Picture
                    css={css({
                        marginBlockEnd: token("space.200")
                    })}
                    image={{
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/scjwn81w6s2ardgn7641002jp2ye5252.svg",
                        alt: ""
                    }}
                />

                <ContentBlock
                    css={contentBlockStyles}
                    headerType={"h3"}
                    headerText={intl.formatMessage({
                        id: "NonprofitPage.enterprise-section.heading.gwp7869",
                        defaultMessage:
                            "Enterprise plans are 50% off for eligible nonprofits and social enterprises."
                    })}
                    ctaProps={{
                        buttonProps: {
                            text: intl.formatMessage({
                                id: "NonprofitPage.enterprise-section.cta",
                                defaultMessage: "Apply now"
                            }),
                            url: localizedCTAHRef
                        }
                    }}
                />
            </div>
            <div css={pictureStyles}>
                <Picture
                    image={{
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/334g168on374sch67v7r1lrv174i8psc.webp",
                        alt: ""
                    }}
                />
            </div>
        </div>
    );
};
EnterpriseSection.displayName = "EnterpriseSection";
